const Account = ({ provider }, args) => {
  const getAddress = async () => {
    const address = provider.publicKey.toString();
    return { address };
  };

  /* istanbul ignore next */
  const getPubKey = async () => {};

  /* istanbul ignore next */
  const signTransaction = async (transaction) => {
    const { signature } = await provider.signAndSendTransaction(transaction);
    return { txHash: signature };
  };

  const sign = async (message) => {};

  /* istanbul ignore next */
  const verifySignature = async (message, signature) => {};

  return {
    getAddress,
    getPubKey,
    sign,
    signTransaction,
    verifySignature,
  };
};

const Backend = ({ provider }) => {
  const genAccount = async (args) => Account({ provider }, args);

  const getAccount = async (args) => genAccount(args);

  const cleanUp = async () => {};

  return {
    getAccount,
    cleanUp,
  };
};

Backend.create = async () => {
  if ("phantom" in window) {
    const provider = window.phantom?.solana;
    if (provider?.isPhantom) {
      await provider.connect();
      return Backend({ provider });
    }
  }
  throw new Error("Phantom is not installed.");
};

export default Backend;
